import request from '@/utils/request'

export function getAllData(section) {
  return request({
    url: '/maharat/getdata',
    method: 'post',
    data: { Section: section }
  })
}


export function saveMaharat(Info) {
  return request({
    url: '/maharat/save',
    method: 'post',
    data: Info
  })
}

export function removeMaharat(Fserial) {
  return request({
    url: '/maharat/Remove',
    method: 'post',
    data: { FSerial_StudentMaharat: Fserial }
  })
}
